import { useUser } from 'core/lite/hooks/useUser';
import * as coreEntities from 'core/store/index';
import { useSelector } from 'react-redux';
import { sendEvent } from '../crud/gamified.crud';
import { useOrganization } from './useOrganization';

const useGamification = () => {
  const { user, isStudent } = useUser();
  const basicInfo = useSelector((state) => coreEntities.gamification.selectors.getUserInfoBasic(state));

  const {
    tenantConfig: { isGamified },
  } = useOrganization();

  function sendGamificationEvent(eventTypeId) {
    if (isStudentGamified()) {
      sendEvent({ userGuid: user.guid, eventTypeId });
    }
  }

  function isStudentGamified() {
    return isGamified && isStudent;
  }

  return {
    sendGamificationEvent,
    basicInfo: basicInfo,
    isStudentGamified: isStudentGamified(),
    isGamified,
  };
};

export default useGamification;
